import { domainRoutes, searchRegistrationRoutes } from './nested-routes'
import TestWizardForm from '@/views/TestWizardForm'
import EditWebsite from '@/views/EditWebsite'
import ViewEmail from '@/views/ViewEmail'
import ViewWebsite from '@/views/ViewWebsite'
import Accounts from '@/views/Accounts'
import ModalTestPage from '@/views/ModalTestPage'
// import DomainManagement from '@/views/DomainManagement'
import Listings from '@/views/ListingsManagement'
import MyDomains from '@/views/MyDomains'
import DomainRegistration from '@/views/DomainRegistration'
import BusinessProfileForm from '@/views/BusinessProfileForm'
import TemplatePicker from '@/views/TemplatePicker'
import ConfigureDomain from '@/views/ConfigureDomain'
import ViewTourNewWindow from '@/views/ViewTourNewWindow'
import EcommTourNewWindow from '@/views/EcommTourNewWindow'

const IntlStructure = () => import(/* webpackChunkName: "structure" */ '@/layout/IntlStructure')
const Dashboard = () => import(/* webpackChunkName: "dashboard" */ '@/views/Dashboard')
const SeoService = () => import(/* webpackChunkName: "seoservice" */ '@/views/SeoService')
const ModFormPage = () => import(/* webpackChunkName: "modform" */ '@/views/ModFormPage')
const NoService = () => import(/* webpackChunkName: "noservice" */ '@/views/NoService')

const routes = [
  {
    path: '/accounts',
    name: 'Accounts',
    component: Accounts,
    meta: {
      requiresAuth: true,
      title: 'My Services - Accounts'
    }
  },
  {
    path: '/bt-tour',
    name: 'btTourNewWindow',
    component: ViewTourNewWindow,
    meta: {
      requiresAuth: false,
      title: 'BT - Tour'
    }
  },
  {
    path: '/online-store-guide',
    name: 'ecommTourNewWindow',
    component: EcommTourNewWindow,
    meta: {
      requiresAuth: false,
      title: 'Online Store Tour'
    }
  },
  {
    path: '/',
    name: 'IntlStructure',
    component: IntlStructure,
    meta: {
      title: 'My Services'
    },
    children: [
      {
        path: 'website-modification',
        name: 'ModFormPage',
        component: ModFormPage,
        meta: {
          requiresAuth: true,
          title: 'My Services - Modifications'
        }
      },
      {
        path: 'main',
        name: 'MainSection',
        component: Dashboard,
        meta: {
          requiresAuth: true,
          title: 'My Services - Dashboard'
        }
      },
      {
        path: 'seoperformance/:serviceId',
        name: 'SeoService',
        component: SeoService,
        meta: {
          requiresAuth: true,
          title: 'My Services - SEO'
        }
      },
      {
        path: '/my-domains',
        name: 'MyDomains',
        component: MyDomains,
        redirect: { name: 'DomainOverview' },
        meta: {
          requiresAuth: true,
          title: 'My Services - SEO'
        },
        children: domainRoutes
      },
      // {
      //   path: 'domain-management',
      //   name: 'DomainManagement',
      //   component: DomainManagement,
      //   meta: {
      //     requiresAuth: true,
      //     title: 'My Services - Domain Management'
      //   }
      // },
      {
        path: 'no-service',
        name: 'NoService',
        component: NoService,
        meta: {
          requiresAuth: true,
          title: 'My Services - No Service'
        }
      },
      {
        path: 'listings',
        name: 'Listings',
        component: Listings,
        meta: {
          requiresAuth: true,
          title: 'My Services - Listings Management'
        }
      },
      {
        path: 'business-profile',
        name: 'BusinessProfileForm',
        component: BusinessProfileForm,
        meta: {
          requiresAuth: true,
          title: 'My Services - Business Profile'
        }
      },
      {
        path: 'template-picker',
        name: 'TemplatePicker',
        component: TemplatePicker,
        meta: {
          requiresAuth: true,
          title: 'Template Picker'
        }
      },
      {
        path: 'configure-domain',
        name: 'ConfigureDomain',
        component: ConfigureDomain,
        meta: {
          requiresAuth: true,
          title: 'Configure your domain'
        }
      },
      // test routes
      {
        path: 'modal-test-page',
        name: 'ModalTestPage',
        component: ModalTestPage,
        meta: {
          requiresAuth: true,
          title: 'My Services - test-modal'
        }
      },
      {
        path: 'edit-website',
        name: 'EditWebsite',
        component: EditWebsite,
        meta: {
          requiresAuth: true,
          title: 'My Services - Edit Website'
        }
      },
      {
        path: 'preview-website',
        name: 'ViewWebsite',
        component: ViewWebsite,
        meta: {
          requiresAuth: true,
          title: 'My Services - View Website'
        }
      },
      {
        path: 'view-email',
        name: 'ViewEmail',
        component: ViewEmail,
        meta: {
          requiresAuth: true,
          title: 'My Services - View Email'
        }
      },
      {
        path: 'test-wizard-form',
        name: 'TestWizardForm',
        component: TestWizardForm,
        meta: {
          requiresAuth: true,
          title: 'My Services - test-wizard-form'
        }
      },

      {
        path: 'domain-registration',
        name: 'DomainRegistration',
        component: DomainRegistration,
        redirect: { name: 'RegistrationSearch' },
        meta: {
          requiresAuth: true,
          title: 'My Services - test-wizard-form'
        },
        children: searchRegistrationRoutes
      }
    ]
  },
  {
    path: '*',
    redirect: '/'
  }
  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '@/views/About.vue')
  // }
]

export default routes
